import React from 'react'

import AddAnotherProgramScreen from '../../screens/AddAnotherProgramScreen'

const AddAnotherProgramme = () => {
  return <AddAnotherProgramScreen></AddAnotherProgramScreen>
}

export default AddAnotherProgramme
